import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    show: {
        id: 'new_card.show_details',
        defaultMessage: 'Show card details',
    },
})
